export default __webpack_public_path__ + "static/media/DebitImage.5d78dba7.svg";